export default __webpack_public_path__ + "static/media/large-park.3d74bbc4.svg";